import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=bf4a639c&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"
import style0 from "./Templates.vue?vue&type=style&index=0&id=bf4a639c&scoped=true&lang=scss&"
import style1 from "./Templates.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4a639c",
  null
  
)

export default component.exports